module.exports = __webpack_public_path__ + "img/7.30ba1fda.jpg";